import { MeterRecord } from '../services/api/inventoryMeters';
import { IndexedDatabase } from './indexedDatabase';

export interface InventoryMeterRecordDb {
  id: string;
  locationApiKey: string;
  meter: MeterRecord;
  wasSynced?: 0 | 1;
}

export class InventoryMetersDB extends IndexedDatabase<InventoryMeterRecordDb> {
  constructor(newData?: InventoryMeterRecordDb[]) {
    super('meters', ['id', 'wasSynced'], newData);
  }

  setSyncedToRecord(id: string | number): Promise<void> {
    return new Promise(resolve => {
      const request = this._openConnection();
      request.onsuccess = () => {
        if (this.database) {
          const transaction = this.database.transaction([this.name], 'readwrite').objectStore(this.name);
          const objectStore = transaction.get(id) as IDBRequest<InventoryMeterRecordDb>;

          objectStore.onsuccess = () => {
            const data = objectStore.result;
            data.wasSynced = 1;

            // Create another request that inserts the item back into the database
            transaction.put(data);
            resolve();
          };
        }
      };
    });
  }

  async countNotSynchronized(): Promise<number> {
    return await new Promise((resolve, reject) => {
      const request = this._openConnection();
      request.onsuccess = () => {
        if (this.database) {
          const countRequest = this.database
            .transaction([this.name], 'readonly')
            .objectStore(this.name)
            .index('wasSynced')
            .count(IDBKeyRange.only(0));

          countRequest.onsuccess = () => {
            resolve(countRequest.result);
          };
          countRequest.onerror = reject;
        }
      };
      request.onerror = reject;
    });
  }
}
